<template>
  <div class="home">
    <template v-if="isReady && !loadError">
    <!-- 顶部导航栏 - 仅服务配置页显示 -->
    <div class="top-bar" v-if="activeTab === 'control'">
      <!-- 左上角：重启服务（与保存按钮分开，避免误触） -->
      <n-popconfirm @positive-click="RestartService">
        <template #trigger>
          <div class="top-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
              <path d="M3 3v5h5" />
              <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
              <path d="M16 21h5v-5" />
            </svg>
          </div>
        </template>
        重启后需等待10秒再尝试登录
      </n-popconfirm>

      <!-- 中间：数据面板 -->
      <div class="top-bar-title">数据面板</div>

      <!-- 右上角：保存设置（状态直接体现在按钮上） -->
      <div class="top-save">
        <NButton
          size="small"
          :type="isDirty ? 'primary' : 'success'"
          @click="SetKillPigConfig()"
        >
          <span class="save-btn-inner">
            <span v-if="isDirty" class="save-pulse"></span>
            <span v-else class="save-check">✓</span>
            {{ isDirty ? '保存设置' : '已保存' }}
          </span>
        </NButton>
      </div>
    </div>

    <!-- 添加主播弹窗 -->
    <n-modal v-model:show="show_add_black_box" preset="dialog" title="添加主播" positive-text="确认" negative-text="取消"
      @positive-click="AddBlackList" @negative-click="CancelBlack">
      <div class="modal-input">
        <NInput v-model:value="dealer_name" placeholder="请输入主播名称" size="large"></NInput>
      </div>
    </n-modal>

    <!-- 设置收益弹窗 -->
    <n-modal v-model:show="show_amount_box" preset="dialog" title="设置收益" positive-text="确认" negative-text="取消"
      @positive-click="SubmitSetAmount" @negative-click="CancelSetAmount">
      <div class="modal-amount">
        <div class="amount-info">
          <span class="amount-label">{{ selectUser.userName }}</span>
          <span class="amount-credit">收益: {{ selectUser.credit ?? 0 }}</span>
        </div>
        <div class="amount-input-row">
          <NInputNumber v-model:value="set_amount" placeholder="输入调整额度" size="large" style="flex: 1"></NInputNumber>
          <NPopconfirm @positive-click="ClearUserAmount">
            <template #trigger>
              <NButton type="error" size="large">清零</NButton>
            </template>
            确定要将 {{ selectUser.userName }} 的收益清零吗？
          </NPopconfirm>
        </div>
        <div class="amount-tip">输入正数为增加，负数为减少</div>
      </div>
    </n-modal>

    <!-- 主内容区 -->
    <div class="main-content">
      <NTabs v-model:value="activeTab" type="line" class="main-tabs">
        <!-- 服务配置 -->
        <NTabPane name="control" tab="服务配置">
          <KillPigControl :input="input" :killPigEnabled="killPigEnabled" :realBalance="realBalance" @update:killPigEnabled="killPigEnabled = $event"
            :selectRooms="selectRooms" :roomList="roomList" :blockList="blockList"
            @addDealer="TryAddBlockList" @deleteDealer="DeleteBlack"
            @clearBetCache="handleClearBetCache" @clearAccountCache="handleClearAccountCache" />
        </NTabPane>

        <!-- 每日概览
        <NTabPane name="overview" tab="每日概览">
          <Overview />
        </NTabPane>
        -->

        <!-- 授权管理 -->
        <NTabPane name="auth" tab="授权管理">
          <AuthManage />
        </NTabPane>

        <!-- 主播列表 -->
        <NTabPane name="recharge" tab="主播列表">
          <AccountList :userList="userList" :totalCount="totalCount" :totalPages="totalPages"
            :currentPage="currentPage" :searchKeyword="searchKeyword" :sortBy="sortBy"
            :refreshingUser="refreshingUser" :refreshingAll="refreshingAll"
            @update:searchKeyword="searchKeyword = $event" @update:currentPage="currentPage = $event"
            @update:sortBy="onSortChange"
            @search="handleSearch" @pageChange="handlePageChange"
            @refreshUser="refreshUserBalance" @refreshAll="refreshAllBalances"
            @toggleNoClear="handleToggleNoClear"
            @modifyBalance="ShowSetAmount" />
        </NTabPane>

        <!-- 线路管理 -->
        <NTabPane name="line" tab="线路管理">
          <LineConfigManage />
        </NTabPane>
      </NTabs>
    </div>

    <!-- 底部导航 -->
    <div class="bottom-nav">
      <div class="nav-item" :class="{ active: activeTab === 'control' }" @click="activeTab = 'control'">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3" />
          <path
            d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" />
        </svg>
        <span class="nav-text">服务配置</span>
      </div>
      <!-- 概览
      <div class="nav-item" :class="{ active: activeTab === 'overview' }" @click="activeTab = 'overview'">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
        <span class="nav-text">概览</span>
      </div>
      -->
      <div class="nav-item" :class="{ active: activeTab === 'auth' }" @click="activeTab = 'auth'">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <span class="nav-text">授权管理</span>
      </div>
      <div class="nav-item" :class="{ active: activeTab === 'recharge' }" @click="activeTab = 'recharge'">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="20" height="14" x="2" y="5" rx="2" />
          <line x1="2" x2="22" y1="10" y2="10" />
        </svg>
        <span class="nav-text">主播列表</span>
      </div>
      <div class="nav-item" :class="{ active: activeTab === 'line' }" @click="activeTab = 'line'">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
        <span class="nav-text">线路管理</span>
      </div>
    </div>
    </template>
    <div v-else class="loading-container">
      <template v-if="!loadError">
        <div class="loading-spinner"></div>
        <span class="loading-text">加载配置中...</span>
      </template>
      <template v-else>
        <span class="loading-text" style="color:var(--kp-bad-soft)">服务连接失败</span>
        <NButton size="small" @click="retryInit">重试</NButton>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import virtual_blacklist from "@/ts/dbvo/virtual_blacklist";
import SignalRClient from "@/ts/SignalRClient";
import Tools from "@/ts/Tools";
import KillPigConfigVO from "@/ts/VO/KillPigConfigVO";
import OutPutStopService from "@/ts/VO/OutPutStopService";
import RoomVO from "@/ts/VO/RoomVO";
import { setRoomNameMap } from "@/ts/roomNameStore";
import AuthManage from "@/views/AuthManage.vue";
import KillPigControl from "@/views/KillPigControl.vue";
// import Overview from "@/views/Overview.vue";
import AccountList from "@/views/AccountList.vue";
import LineConfigManage from "@/views/LineConfigManage.vue";
import {
  createDiscreteApi,
  NButton,
  NInput,
  NInputNumber,
  NPopconfirm,
  NTabs,
  NTabPane,
} from "naive-ui";
import { ref, watch, onUnmounted, computed } from "vue";
import { useRoute } from "vue-router";

type OutPutGetAllBlockList = {
  flag: boolean;
  errorMessage: string;
  list: virtual_blacklist[];
};

type OutPutMessage = {
  flag: boolean;
  errorMessage: string;
};

const route = useRoute();
const api = createDiscreteApi(["message"]);

const show_add_black_box = ref(false);
/**
 * 是否显示收益框
 */
const show_amount_box = ref<boolean>(false);
const set_amount = ref<number>();
const dealer_name = ref<string>();

//#region 受控房间

const roomList = ref<RoomVO[]>([]);
const userList = ref<any[]>([]);
const blockList = ref<virtual_blacklist[]>([]);

const selectUser = ref<any>({});

const selectRooms = ref<(string | number)[]>([]);
const killPigEnabled = ref(false);
const isReady = ref(false);
const loadError = ref(false);

// 分页和搜索
const searchKeyword = ref('');
const currentPage = ref(1);
const pageSize = ref(10);
const sortBy = ref('id');
const totalCount = ref(0);
const totalPages = ref(1);

// 刷新收益
const refreshingUser = ref<string | null>(null);
const refreshingAll = ref(false);

// 底部导航
const activeTab = ref((route.query.tab as string) || 'control');

//#endregion

const input = ref<KillPigConfigVO>(new KillPigConfigVO());

// 未保存变更检测：以“保存按钮实际持久化的数据”（配置 input + 房间勾选 selectRooms）为基线，
// 与当前编辑态做深比较。服务端推送（applyRoomList）或初始加载后需重置基线，避免误报。
// RealServerBalance 为实时展示字段（不编辑、不随保存变化），比较时剔除，否则会误判为已改动。
const savedInputSnapshot = ref<string>('');
const savedRoomsSnapshot = ref<string>('');
const isDirty = computed(() => {
  if (!savedInputSnapshot.value) return false; // 尚未建立基线（加载中）
  const curInput = snapshotInputConfig();
  const curRooms = JSON.stringify([...selectRooms.value].sort());
  return curInput !== savedInputSnapshot.value || curRooms !== savedRoomsSnapshot.value;
});
function snapshotInputConfig(): string {
  const clone: Record<string, unknown> = { ...(input.value as any) };
  delete (clone as any).RealServerBalance;
  return JSON.stringify(clone);
}
function baselineSavedState() {
  savedInputSnapshot.value = snapshotInputConfig();
  savedRoomsSnapshot.value = JSON.stringify([...selectRooms.value].sort());
}

// 真实服务器账号余额：独立轮询刷新（只更新展示值，不覆盖用户未保存的配置编辑）
const realBalance = ref<number>(0);
let balanceTimer: number | null = null;

async function RefreshRealBalance() {
  try {
    const cfg = await SignalRClient.Instance.InvokeAsync<KillPigConfigVO>("GetKillPigConfig");
    if (cfg?.RealServerBalance != null) realBalance.value = cfg.RealServerBalance;
  } catch {
    /* 静默失败，下一轮再试 */
  }
}

function StartBalancePolling() {
  RefreshRealBalance();
  balanceTimer = window.setInterval(RefreshRealBalance, 5000);
}

function StopBalancePolling() {
  if (balanceTimer != null) {
    window.clearInterval(balanceTimer);
    balanceTimer = null;
  }
}

onUnmounted(StopBalancePolling);

// 订阅服务端推送的实时余额（下注成功/结算/登录时推送），比轮询更及时
SignalRClient.Instance.AddEventListener("onBalanceUpdate", (b: any) => {
  const v = typeof b === "number" ? b : Number(b);
  if (!isNaN(v)) realBalance.value = v;
});
onUnmounted(() => SignalRClient.Instance.RemoveEventListener("onBalanceUpdate"));

// 服务端房间列表变化（拉取数据 关<->开 重建/销毁房间）时实时推送，无需刷新页面即可更新房间列表与杀猪勾选
SignalRClient.Instance.AddEventListener("onRoomListUpdate", (respRoomObj: { [key: string]: RoomVO }) => {
  applyRoomList(respRoomObj);
});
onUnmounted(() => SignalRClient.Instance.RemoveEventListener("onRoomListUpdate"));

// 服务端推送的账号状态（在线 / 上线时间 / 最后离线时间 / 所在房间），实时更新列表展示
SignalRClient.Instance.AddEventListener("onUserStatusUpdate", (data: any) => {
  const name = data?.userName;
  if (!name) return;
  const u = userList.value.find((x: any) => x.userName === name);
  if (!u) return;
  u.online = !!data.online;
  u.onlineTime = data.onlineTime;
  u.lastOfflineTime = data.lastOfflineTime;
  u.room = data.room;
});
onUnmounted(() => SignalRClient.Instance.RemoveEventListener("onUserStatusUpdate"));

async function InitAsync() {
  try {
    // 等待配置和房间列表加载完成（连接超时由 SignalRClient 内部 10 秒兜底）
    await Promise.all([
      SignalRClient.Instance.InvokeAsync<KillPigConfigVO>("GetKillPigConfig").then(x => { input.value = x; }),
      (async () => {
        var respRoomObj = await SignalRClient.Instance.InvokeAsync<{ [key: string]: RoomVO }>("GetRoomList");
        for (const key in respRoomObj) {
          const room = respRoomObj[key];
          Object.setPrototypeOf(room, RoomVO.prototype);
          if (room.OpenKillPig) {
            selectRooms.value?.push(room.RoomNumber);
          }
          roomList.value.push(room);
        }
        setRoomNameMap(roomList.value);
      })(),
    ]);
    killPigEnabled.value = selectRooms.value.length > 0;
    baselineSavedState(); // 加载完成即建立“已保存”基线
  } catch (e) {
    console.error('初始化失败:', e);
    loadError.value = true;
  } finally {
    isReady.value = true;
  }

  // 后台加载，不阻塞显示
  GetUserListAsync();
  GetAllBlockListAsync();

  // 启动真实账号余额轮询（每 5 秒），不影响配置编辑
  StartBalancePolling();
}

function retryInit() {
  loadError.value = false;
  isReady.value = false;
  InitAsync();
}

// 服务端推送的房间列表实时覆盖本地：保留仍存在的房间的本地勾选（未保存也不丢），并补入服务端已开启的房间
function applyRoomList(respRoomObj: { [key: string]: RoomVO }) {
  const newList: RoomVO[] = [];
  for (const key in respRoomObj) {
    const room = respRoomObj[key];
    Object.setPrototypeOf(room, RoomVO.prototype);
    newList.push(room);
  }
  roomList.value = newList;
  setRoomNameMap(newList);
  const existing = new Set(newList.map(r => r.RoomNumber));
  const keep = (selectRooms.value ?? []).filter((rn: any) => existing.has(rn));
  const serverOn = newList.filter(r => r.OpenKillPig).map(r => r.RoomNumber!);
  selectRooms.value = Array.from(new Set<(string | number)>([...(keep as (string | number)[]), ...serverOn]));
  killPigEnabled.value = selectRooms.value.length > 0;
  baselineSavedState(); // 服务端推送代表权威状态，重置基线避免误报未保存
}

/**
 * 获取用户列表（含统计信息）
 */
async function GetUserListAsync() {
  Tools.FetchGetAsync<{
    allcount: number;
    pagecount: number;
    data: any;
  }>("game/account-stats", {
    page: currentPage.value,
    pageSize: pageSize.value,
    sortBy: sortBy.value,
    userName: searchKeyword.value || undefined,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      userList.value = resp.Data?.data || [];
      totalCount.value = resp.Data?.allcount || 0;
      totalPages.value = resp.Data?.pagecount || 1;
    }
  });
}

/**
 * 获取黑名单列表
 */
async function GetAllBlockListAsync() {
  var blockListItem =
    await SignalRClient.Instance.InvokeAsync<OutPutGetAllBlockList>(
      "GetAllBlockList"
    );
  if (blockListItem.flag) {
    blockList.value = blockListItem.list;
  }
}

/**
 * 添加黑名单
 */
function AddBlackList() {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>(
    "AddBlockList",
    dealer_name.value
  ).then((resp) => {
    if (!resp.flag) {
      Tools.AlertError(resp.errorMessage);
    } else {
      Tools.AlertSuccess("添加成功!");
      GetAllBlockListAsync();
    }
  });
}

/**
 * 删除黑名单
 */
function DeleteBlack(id: number) {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>(
    "RemoveBlockFromID",
    id
  ).then((resp) => {
    if (!resp.flag) {
      Tools.AlertError(resp.errorMessage);
    } else {
      Tools.AlertSuccess("删除成功!");
      GetAllBlockListAsync();
    }
  });
}

/**
 * 尝试添加黑名单
 */
function TryAddBlockList() {
  dealer_name.value = "";
  show_add_black_box.value = true;
}

// 开关联动 selectRooms
watch(killPigEnabled, (enabled) => {
  if (enabled) {
    selectRooms.value = roomList.value.map(r => r.RoomNumber);
  } else {
    selectRooms.value = [];
  }
});

function CancelBlack() {
  show_add_black_box.value = false;
}

/**
 * 充值服务
 */
function RestartService() {
  SignalRClient.Instance.InvokeAsync<OutPutStopService>("RestartService").then(
    (x) => {
      if (x.Ok) {
        Tools.AlertSuccess("重启服务命令已成功发送,等待10秒后，重新尝试登录!");
      }
      else {
        Tools.AlertError(x.ErrorMessage);
      }
    }
  );
}

/**
 * 保存服务配置
 * @param config
 */
async function SetKillPigConfig() {
  // 注意调用顺序：必须先 SetKillPig（落地房间杀猪最终状态），再 SetKillPigConfig（保存总配置）。
  // ChatHub.SetKillPigConfig 内部会按“任意房间 OpenKillPig”强制把拉取数据改回开启；
  // 若先存配置、后清房间，强制判断会看到尚未清掉的旧 OpenKillPig=true，导致“三个同时关”时
  // 拉取数据被错误地重新开启（关不掉）。先清房间再保存配置即可正确关闭。
  const killPigOk = await SignalRClient.Instance.InvokeAsync<boolean>(
    "SetKillPig",
    selectRooms.value
  );
  const configOk = await SignalRClient.Instance.InvokeAsync<boolean>(
    "SetKillPigConfig",
    input.value
  );

  if (configOk && killPigOk) {
    // 重新拉取最新配置：服务端在“杀猪/保持链接”开启时会强制把拉取数据改回开启，
    // 必须把纠正后的状态同步回前端，否则本地仍停在用户关闭时的旧值。
    try {
      const latest = await SignalRClient.Instance.InvokeAsync<KillPigConfigVO>("GetKillPigConfig");
      if (latest) input.value = latest;
    } catch {
      /* 拉取失败不影响本次保存结果，下一轮刷新会补齐 */
    }

    // 同步本地房间“杀猪”状态：SetKillPig 已按 selectRooms 更新服务端 OpenKillPig，
    // 这里把本地 roomList.OpenKillPig 一并对齐，确保“拉取数据”锁（杀猪开启时）正确生效。
    const selected = new Set(selectRooms.value ?? []);
    for (const room of roomList.value) {
      room.OpenKillPig = selected.has(room.RoomNumber);
    }

    baselineSavedState(); // 保存成功后重置基线，清除“未保存”标记
    api.message.success("设置成功!");
  } else {
    api.message.error("设置失败!");
  }
}

/**
 * 显示设置金额
 * @param v
 */
function ShowSetAmount(v: any) {
  selectUser.value = v;
  //显示窗口
  set_amount.value = undefined;
  show_amount_box.value = true;
}

/**
 * 确认充值
 */
function SubmitSetAmount() {
  Tools.FetchGetAsync("game/set-amount", {
    userName: selectUser.value.userName,
    amount: set_amount.value,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess("设置成功!");
      GetUserListAsync();
    }
  });
}

/**
 * 刷新单个用户（收益 + 直播统计）
 */
function refreshUserBalance(user: any) {
  refreshingUser.value = user.userName;
  Tools.FetchGetAsync<{
    userName: string;
    credit: number;
    betCount: number;
    totalBetAmount: number;
    totalWinAmount: number;
    totalEffectiveAmount: number;
  }>("game/refresh-balance", {
    userName: user.userName,
  }).then((resp) => {
    if (resp.CheckIsOk() && resp.Data) {
      const index = userList.value.findIndex(u => u.userName === user.userName);
      if (index !== -1) {
        userList.value[index].credit = resp.Data.credit;
        userList.value[index].betCount = resp.Data.betCount;
        userList.value[index].totalBetAmount = resp.Data.totalBetAmount;
        userList.value[index].totalWinAmount = resp.Data.totalWinAmount;
        userList.value[index].totalEffectiveAmount = resp.Data.totalEffectiveAmount;
      }
      Tools.AlertSuccess(`${user.userName} 已刷新`);
    }
    refreshingUser.value = null;
  }).catch(() => {
    refreshingUser.value = null;
  });
}

/**
 * 刷新全部用户（收益 + 直播统计）
 */
function refreshAllBalances() {
  if (userList.value.length === 0) {
    Tools.AlertError("当前列表为空");
    return;
  }
  refreshingAll.value = true;
  const userNames = userList.value.map(u => u.userName).join(',');
  Tools.FetchGetAsync<Array<{
    userName: string;
    credit: number;
    betCount: number;
    totalBetAmount: number;
    totalWinAmount: number;
    totalEffectiveAmount: number;
  }>>("game/refresh-all-balance", {
    userNames: userNames,
  }).then((resp) => {
    if (resp.CheckIsOk() && resp.Data) {
      resp.Data.forEach(item => {
        const index = userList.value.findIndex(u => u.userName === item.userName);
        if (index !== -1) {
          userList.value[index].credit = item.credit;
          userList.value[index].betCount = item.betCount;
          userList.value[index].totalBetAmount = item.totalBetAmount;
          userList.value[index].totalWinAmount = item.totalWinAmount;
          userList.value[index].totalEffectiveAmount = item.totalEffectiveAmount;
        }
      });
      Tools.AlertSuccess("全部已刷新");
    }
    refreshingAll.value = false;
  }).catch(() => {
    refreshingAll.value = false;
  });
}

/**
 * 取消
 */
function CancelSetAmount() { }

/**
 * 清空账号收益
 */
function ClearUserAmount() {
  const currentCredit = selectUser.value.credit ?? 0;
  Tools.FetchGetAsync("game/set-amount", {
    userName: selectUser.value.userName,
    amount: -currentCredit,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess(`已将 ${selectUser.value.userName} 收益清零!`);
      GetUserListAsync();
      show_amount_box.value = false;
    }
  });
}

/**
 * 搜索
 */
function handleSearch() {
  currentPage.value = 1;
  GetUserListAsync();
}

/**
 * 排序切换
 */
function onSortChange(val: string) {
  sortBy.value = val;
  currentPage.value = 1;
  GetUserListAsync();
}

/**
 * 分页切换
 */
function handlePageChange(page: number) {
  currentPage.value = page;
  GetUserListAsync();
}

/**
 * 清空交易数据（该时间之前的记录不统计）
 */
function handleClearBetCache() {
  Tools.FetchGetAsync<any>("game/clear-bet-cache", {}).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess(`清空交易成功! 时间: ${resp.Data?.time_text || ''}`);
      currentPage.value = 1;
      GetUserListAsync();
    }
  });
}

/**
 * 清空账号显示（该时间之前没有交易记录的账号不显示）
 */
function handleClearAccountCache() {
  Tools.FetchGetAsync<any>("game/clear-account-cache", {}).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess(`清空账号成功! 时间: ${resp.Data?.time_text || ''}`);
      currentPage.value = 1;
      GetUserListAsync();
    }
  });
}

/**
 * 切换账号不清空标记
 */
function handleToggleNoClear(user: any) {
  const newVal = user.noClear ? 0 : 1;
  Tools.FetchGetAsync<any>("game/set-no-clear", {
    userName: user.userName,
    noClear: newVal,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      user.noClear = newVal === 1;
      GetUserListAsync();
    }
  });
}

InitAsync();
</script>

<style scoped lang="scss">
.home {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 12px;
  gap: 10px;
  box-sizing: border-box;
}

// 弹窗样式
.modal-input {
  padding: 8px 0;
}

// 设置收益弹窗
.modal-amount {
  display: flex;
  flex-direction: column;
  gap: 14px;

  .amount-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .amount-label {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: .6px;
      color: var(--kp-gold-hi);
    }

    .amount-credit {
      font-size: 13px;
      color: var(--kp-muted);
      font-family: var(--kp-mono);
    }
  }

  .amount-input-row {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .amount-tip {
    font-size: 12px;
    color: var(--kp-faint);
    letter-spacing: .3px;
  }
}

// 主内容区
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.main-tabs {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  :deep(.n-tabs-nav) {
    display: none;
  }

  // 穿透 naive-ui 内部所有可能的内容包裹层
  :deep(.n-tabs-pane-wrapper),
  :deep(.n-tabs__pane-wrapper),
  :deep(.n-tabs__content) {
    flex: 1;
    display: flex !important;
    flex-direction: column;
    min-height: 0;
    height: 100%;
    position: static !important;
  }

  // 只对可见的 tab pane 设 flex，display:none 的保持隐藏
  :deep(.n-tab-pane:not([style*="display: none"])) {
    flex: 1;
    display: flex !important;
    flex-direction: column;
    min-height: 0;
    height: 100%;
    position: static !important;
    padding: 0 !important;
  }
}

// 顶部导航栏（重启服务在左，标题居中，保存设置居右）
.top-bar {
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 10px 14px;
  border-radius: var(--kp-radius);
  background-image:
    radial-gradient(90% 130% at 50% -40%, rgba(216,178,95,.16), transparent 72%),
    linear-gradient(158deg, #17130e 0%, #0e0c0a 58%, #120f0b 100%);
  border: 1px solid var(--kp-gold-line-strong);
  box-shadow:
    0 16px 34px -24px #000,
    inset 0 1px 0 rgba(255,235,198,.12),
    inset 0 0 32px -18px rgba(216,178,95,.26);

  // 顶部一道金线，像器物的镶边
  &::before {
    content: '';
    position: absolute;
    left: 12px;
    right: 12px;
    top: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(246,226,178,.62) 22%, rgba(255,246,224,.92) 50%, rgba(246,226,178,.62) 78%, transparent);
    animation: kp-edge-glow 2.6s ease-in-out infinite;
    pointer-events: none;
  }

  .top-bar-title {
    grid-column: 2;
    justify-self: center;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 3px;
    text-indent: 3px;
    text-align: center;
    background-image: linear-gradient(180deg, #fdf3da, #d9b773 60%, #b3893f);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    filter: drop-shadow(0 1px 0 rgba(0,0,0,.6));
  }

  .top-icon {
    grid-column: 1;
    justify-self: start;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    color: var(--kp-gold);
    cursor: pointer;
    border-radius: 9px;
    background: rgba(216,178,95,.07);
    border: 1px solid rgba(216,178,95,.20);
    transition: background .18s, border-color .18s, box-shadow .18s;

    &:hover {
      background: rgba(216,178,95,.14);
      border-color: rgba(240,208,138,.45);
      box-shadow: 0 0 18px -8px rgba(240,208,138,.65);
    }
  }

  .top-save {
    grid-column: 3;
    justify-self: end;
  }
}

.save-btn-inner {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  letter-spacing: .6px;
  font-weight: 600;
}

.save-pulse {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  animation: savePulse 1.2s ease-in-out infinite;
}

.save-check {
  color: currentColor;
  font-weight: 800;
  font-size: 12px;
}

@keyframes savePulse {
  0%, 100% { opacity: .35; transform: scale(.8); }
  50%      { opacity: 1;   transform: scale(1.15); }
}

// 底部导航
.bottom-nav {
  position: sticky;
  top: 100%;
  width: 100%;
  display: flex;
  padding: 4px;
  border-radius: var(--kp-radius);
  background-image:
    radial-gradient(90% 160% at 50% 130%, rgba(216,178,95,.10), transparent 70%),
    linear-gradient(158deg, #17130e 0%, #0e0c0a 60%, #120f0b 100%);
  border: 1px solid var(--kp-gold-line);
  box-shadow:
    0 14px 32px -22px #000,
    inset 0 1px 0 rgba(255,235,198,.08);

  .nav-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    padding: 7px 0;
    color: var(--kp-faint);
    cursor: pointer;
    border-radius: 10px;
    transition: color .2s, background .2s, box-shadow .2s;

    svg {
      width: 19px;
      height: 19px;
    }

    &.active {
      color: var(--kp-gold-hi);
      background: linear-gradient(180deg, rgba(216,178,95,.26), rgba(168,124,57,.10));
      box-shadow:
        0 0 18px -8px rgba(240,208,138,.55),
        inset 0 1px 0 rgba(255,242,208,.14);
    }

    &:hover:not(.active) {
      color: var(--kp-text-2);
      background: rgba(216,178,95,.06);
    }

    .nav-text {
      font-size: 11.5px;
      letter-spacing: .8px;
      font-weight: 600;
    }
  }
}

@media (max-width: 480px) {
  .home {
    padding: 10px;
    gap: 12px;
  }
}

// 加载中
.loading-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: var(--kp-muted);

  .loading-spinner {
    width: 36px;
    height: 36px;
    border: 2px solid rgba(216, 178, 95, 0.16);
    border-top-color: var(--kp-gold);
    border-radius: 50%;
    box-shadow: 0 0 28px -12px rgba(216, 178, 95, 0.85);
    animation: spin 0.9s linear infinite;
  }

  .loading-text {
    font-size: 13px;
    letter-spacing: 1.2px;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
